import { useState, useCallback } from 'react';
import type { IBankAccount, IBankAccountFormData } from '@/@types/invoice';

function getInitialForm(existing?: IBankAccount): IBankAccountFormData {
  return {
    bankName: existing?.bankName ?? '',
    accountHolderName: existing?.accountHolderName ?? '',
    accountNumber: existing?.accountNumber ?? '',
    iban: existing?.iban ?? '',
    swiftCode: existing?.swiftCode ?? '',
    currency: existing?.currency ?? 'EUR',
    isPrimary: existing?.isPrimary ?? false,
  };
}

export function useBankAccountForm(existingAccount?: IBankAccount) {
  const [form, setForm] = useState<IBankAccountFormData>(() => getInitialForm(existingAccount));
  const [isSubmitting, setIsSubmitting] = useState(false);

  const setField = useCallback(
    <K extends keyof IBankAccountFormData>(key: K, value: IBankAccountFormData[K]) => {
      setForm(prev => ({ ...prev, [key]: value }));
    },
    []
  );

  const resetForm = useCallback(() => {
    setForm(getInitialForm(existingAccount));
  }, [existingAccount]);

  return { form, setField, resetForm, isSubmitting, setIsSubmitting };
}
